import React, {memo} from "react";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import StyledToolTip from "../../../components/common/StyledToolTip";
import DispatchDriverIcon from "../../icons/DispatchDriverIcon";
class CreateDispatch extends React.Component {
  constructor(props) {
    super(props);
  }

  onCreateDispatch = () => {
    this.props.eventHub.emit("createDispatch");
  };

  render() {
    const { classes, enableDispatchDriver } = this.props;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          enableDispatchDriver ? classes.enabledIcon : classes.disableIcon
        }`}
        onClick={enableDispatchDriver ? this.onCreateDispatch : null}
      >
        <StyledToolTip
          title={
            enableDispatchDriver
              ? "Dispatch Driver"
              : "Dispatch Driver (Disabled)"
          }
        >
          <div>
            <DispatchDriverIcon height={18} width={18} />
          </div>
        </StyledToolTip>
      </div>
    );
  }
}

export default withStyles(styles)(memo(CreateDispatch));
